import { DEFAULT_PAGE } from "../../contstants";
import getDateRange from "../../utils/getDateRange";
import { GetReplaceOrders } from "./getReplaceOrders";

const FilterReplaceOrders = async (perPage, filters) => {
  const page = filters.page || DEFAULT_PAGE;
  const type = "replace";
  const searchInFields = filters.search_in_fields || "user";
  const searchPhrase = filters.s;
  const user = searchInFields.includes("user") ? searchPhrase : "";
  const id = searchInFields.includes("id") ? searchPhrase : "";
  const status = filters.status === "all" ? "" : filters.status || "";
  const office_id = filters.office_id;
  const { dateFrom, dateTo } = getDateRange(filters.date);

  return await GetReplaceOrders({
    limit: perPage,
    offset: (page - 1) * perPage,
    type,
    office_id,
    dateFrom,
    dateTo,
    id,
    user,
    status,
  });
};

export default FilterReplaceOrders;
